(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expert-insights"] && !Shopify.designMode) return;
  try {
    
  class ExpertCarousel {
    constructor(element) {
      this.carousel = element;
      this.slides = Array.from(this.carousel.querySelectorAll('.carousel-slide'));
      this.dots = Array.from(this.carousel.querySelectorAll('.pagination-dots .dot'));
      this.prevBtn = this.carousel.querySelector('.carousel-prev');
      this.nextBtn = this.carousel.querySelector('.carousel-next');
      this.currentSlide = 0;
      this.totalSlides = this.slides.length || 0;

      this.init();
    }

    init() {
      if (this.totalSlides === 0) return;

      // Ensure initial active slide/dot are synced
      this.slides.forEach((s, i) => s.classList.toggle('active', i === this.currentSlide));
      this.dots.forEach((d, i) => d.classList.toggle('active', i === this.currentSlide));

      // Attach listeners (guard in case controls are missing)
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prevSlide());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.nextSlide());

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      this.updateControls();
    }

    goToSlide(index) {
      if (index < 0 || index >= this.totalSlides || index === this.currentSlide) return;

      // Toggle slide active classes
      this.slides[this.currentSlide].classList.remove('active');
      this.slides[index].classList.add('active');

      // Toggle dot active classes (if dots exist)
      if (this.dots.length === this.totalSlides) {
        this.dots[this.currentSlide].classList.remove('active');
        this.dots[index].classList.add('active');
      }

      this.currentSlide = index;
      this.updateControls();
    }

    nextSlide() {
      const nextIndex = this.currentSlide + 1;
      if (nextIndex < this.totalSlides) {
        this.goToSlide(nextIndex);
      }
    }

    prevSlide() {
      const prevIndex = this.currentSlide - 1;
      if (prevIndex >= 0) {
        this.goToSlide(prevIndex);
      }
    }

    updateControls() {
      if (this.prevBtn) this.prevBtn.disabled = this.currentSlide === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentSlide === this.totalSlides - 1;
    }
  }

  // Initialize carousels when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach((carousel) => new ExpertCarousel(carousel));
  });

  // Re-initialize if section is reloaded in theme editor
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      const carousels = document.querySelectorAll('[data-carousel]');
      carousels.forEach((carousel) => new ExpertCarousel(carousel));
    });
  }

  } catch(e) { console.error(e); }
})();
})();
